import React from 'react';

export interface SvgLocationMarkerProps {
  className?: string;
}

const SvgLocationMarker: React.FC<SvgLocationMarkerProps> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 27 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_biiiiiii_6117_7340)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.7663 22.9026C27.7805 17.8884 27.7806 9.75885 22.7663 4.74456C17.752 -0.269726 9.62251 -0.269615 4.60833 4.74456C-0.405846 9.75873 -0.405957 17.8883 4.60833 22.9026L13.6873 31.9816L22.7663 22.9026Z"
          fill="#12A791"
          fillOpacity="0.4"
        />
      </g>
      <defs>
        <filter
          id="filter0_biiiiiii_6117_7340"
          x="-19.6958"
          y="-19.5596"
          width="66.7666"
          height="72.0845"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="10.2717" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_6117_7340"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_6117_7340"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.213995" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_6117_7340"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.42391" />
          <feGaussianBlur stdDeviation="1.71196" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_6117_7340"
            result="effect3_innerShadow_6117_7340"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.855978" />
          <feGaussianBlur stdDeviation="0.213995" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_innerShadow_6117_7340"
            result="effect4_innerShadow_6117_7340"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.427989"
            operator="erode"
            in="SourceAlpha"
            result="effect5_innerShadow_6117_7340"
          />
          <feOffset dy="-1.06997" />
          <feGaussianBlur stdDeviation="0.213995" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
          />
          <feBlend
            mode="hard-light"
            in2="effect4_innerShadow_6117_7340"
            result="effect5_innerShadow_6117_7340"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.855978" />
          <feGaussianBlur stdDeviation="0.213995" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.231373 0 0 0 0 0.960784 0 0 0 0 0.803922 0 0 0 0.5 0"
          />
          <feBlend
            mode="screen"
            in2="effect5_innerShadow_6117_7340"
            result="effect6_innerShadow_6117_7340"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-0.855978" dy="0.855978" />
          <feGaussianBlur stdDeviation="1.28397" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.231373 0 0 0 0 0.960784 0 0 0 0 0.803922 0 0 0 0.6 0"
          />
          <feBlend
            mode="screen"
            in2="effect6_innerShadow_6117_7340"
            result="effect7_innerShadow_6117_7340"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.855978" dy="-0.855978" />
          <feGaussianBlur stdDeviation="1.28397" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.231373 0 0 0 0 0.960784 0 0 0 0 0.803922 0 0 0 0.6 0"
          />
          <feBlend
            mode="screen"
            in2="effect7_innerShadow_6117_7340"
            result="effect8_innerShadow_6117_7340"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default SvgLocationMarker;
